import { Box, Modal } from '@mui/material';
import cashIcon from "assets/images/coin-icon.png";
import cardIcon from "assets/images/mastercard-icon.png";
import upiIcon from "assets/images/upi-icon.png";
import sodexo from "assets/images/sodexo.png";
import { useContext, useState } from 'react';
import { UserContext } from '../../../../../App';
import useGetDevice from '../../hooks/useGetDevice';
import StyledButton from '../../all-products/components/custom/StyledButton';
import StyledInput from '../../all-products/components/custom/StyledInput';
import "./recordPaymentModal.css";
import { completePayment } from '../../../../../config/Services';
import { useSnackbar } from '../../hooks/SnackbarProvider';


export const RecordPaymentModal = (props) => {
    const { color } = useContext(UserContext);
    const isMobile = useGetDevice();
    const paymentMethodsString = localStorage.getItem("paymentMethods");
    const payment_modes = paymentMethodsString?.split(",");
    const [rpLoader, setRpLoader] = useState(false);
    const [amount, setAmount] = useState("");
    const [paymentMd, setPaymentMd] = useState("CASH");
    const showSnackbar = useSnackbar();


    const handleDeliveryRecordPayemnt = () => {
        let payload = {
            referenceId: props.orderId,
            paymentStatus: "COMPLETED",
            amountPaid: amount,
            paymentType: "MANUAL",
            paymentMethod: paymentMd,
            paymentMode: "OFFLINE"
        };
        setRpLoader(true)
        completePayment(payload).then((res) => {
            showSnackbar("Payment completed successfully", "success")
            setRpLoader(false)
            props.setState(false)
            props.handleCloseRecordPayment();
            props.setUpdate(!props.update)
        }).catch((err) => {
            setRpLoader(false)
            showSnackbar(err.message || err?.response?.data?.message, "error");
        })
    }

    const handleClear = () => {
        setAmount("")
    }

    return (
        <Modal open={props.openRecordPayment} onClose={props.handleCloseRecordPayment}>
            <Box
                sx={{
                    backgroundColor: color === "dark" ? "#353a50" : "#fff",
                    color: color === "dark" ? "white" : "black",
                    position: isMobile ? "static" : "fixed",
                    top: "50%",
                    left: "10%",
                    maxWidth: isMobile ? "100%" : "40%",
                    maxHeight: "100%",
                    transform: isMobile ? "none" : "translate(50%, -50%)",
                    width: isMobile ? "100%" : "50%",
                    display: isMobile ? "flex" : "block",
                    borderRadius: "10px",
                    padding: "1.5rem",
                    flexDirection: "column",
                    justifyContent: "center",
                    ...(isMobile && { height: "100%" }),
                }}
            >
                <div className=''>
                    <p>Select the Payment Method</p>
                    <div className="split-payment-new-container">
                        {/* <button
                                    onClick={() => props.setSplitActive(false)}
                                    className={props.splitActive ? "activePaymentIcon-splitI" : "paymenticons-split"}
                                >
                                    <img className="cashIcon-img" src={props.splitImg} alt="err" />
                                    <b className="text-active-icon">SPLIT</b>
                                </button> */}
                        <div className="paymentIconsContainer-modal-I-keyboard" id="myDivPayment">
                            {payment_modes?.includes("CASH") && (
                                <button
                                    onClick={() => setPaymentMd("CASH")}
                                    className={
                                        paymentMd === "CASH"
                                            ? "activePaymentIcon-I"
                                            : "paymenticons-I"
                                    }
                                >
                                    <img className="cashIcon-img" src={cashIcon} alt="err" />
                                    <b className="text-active-icon"> Cash</b>
                                </button>
                            )}

                            {payment_modes?.includes("UPI") && (
                                <button
                                    onClick={() => setPaymentMd("UPI")}
                                    className={
                                        paymentMd === "UPI"
                                            ? "activePaymentIcon-I"
                                            : "paymenticons-I"
                                    }
                                >
                                    <img className="cashIcon-img" src={upiIcon} alt="err" />
                                    <b className="text-active-icon"> UPI</b>
                                </button>
                            )}

                            {payment_modes?.includes("CARD") && (
                                <button
                                    onClick={() => setPaymentMd("CARD")}
                                    className={
                                        paymentMd === "CARD"
                                            ? "activePaymentIcon-I"
                                            : "paymenticons-I"
                                    }
                                >
                                    <img className="cashIcon-img" src={cardIcon} alt="err" />
                                    <b className="text-active-icon"> CARD</b>
                                </button>
                            )}

                            {payment_modes?.includes("SODEXO") && (
                                <button
                                    onClick={() => setPaymentMd("SODEXO")}
                                    className={
                                        paymentMd === "SODEXO"
                                            ? "activePaymentIcon-I"
                                            : "paymenticons-I"
                                    }
                                >
                                    <img className="cashIcon-img" src={sodexo} alt="err" />
                                    <b className="text-active-icon"> SODEXO</b>
                                </button>
                            )}
                            <button
                                onClick={() => handleClear()}
                                className="split-payment-cancel"
                            // ref={cancelRef}
                            >
                                <b className="text-active-icon"> CLEAR</b>
                            </button>
                        </div>
                    </div>
                    <StyledInput
                        type="number"
                        placeholder='Enter the amount recieved'
                        sx={{ width: "100%" }}
                        autoFocus
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                    <div className='record-payment-button'>
                        <StyledButton fullWidth onClick={props.handleCloseRecordPayment}>
                            Cancel
                        </StyledButton>
                        <StyledButton fullWidth loading={rpLoader} onClick={handleDeliveryRecordPayemnt}>
                            Record Payment
                        </StyledButton>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}